<template>
  <div class="d-flex flex-row align-items-center">
    <money v-model="priceModal"
           v-bind="money"
           class="rounded input-small"
    ></money>
    <multiselect
      class="ml-1 input-small"
      :searchable="false"
      v-model="currencyModal"
      label="label"
      track-by="label"
      placeholder=""
      :options="currencyOptions"
      :preselect-first="true"
      :allow-empty="false"
      select-label=""
      selected-label=""
      deselect-label=""
    >
      <template slot="noResult">
        {{$t('global.no_results')}}
      </template>
    </multiselect>
    <b-button
      @click="debouncechangeContentPrice"
      :disabled="buttonDisabled"
      size="sm"
      class="py-0 ml-2"
    >{{$t('button.save')}}
    </b-button>
  </div>
</template>

<script>
  import {Money} from 'v-money';
  import {debounce} from 'lodash'

  export default {
    props: {
      row: {
        type: Object,
        required: true
      },
    },
    components: {Money},
    data() {
      return {
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        priceModal: 0,
        currencyModal: null,
        buttonDisabled: true,
        debouncechangeContentPrice: () => {
        }
      }
    },
    computed: {
      currencyOptions() {
        return this.$store.getters['currency/currency']
      },
    },
    created() {
      this.$store.dispatch('currency/getCurrency');
      this.priceModal = this.formatToDollars(this.row.price);
      this.currencyModal = this.formatOption(this.row.currency, 'label');

      this.debouncechangeContentPrice = debounce(this.changeContentPrice, 500)
    },
    methods: {
      changeContentPrice() {
        this.putData(`content/${this.row.key}`,
            {
              price: this.formatToCents(this.priceModal),
              currency: this.getValueOf(this.currencyModal)
            })
            .then(() => {
              this.buttonDisabled = true
            })
      },
      handleButtonState() {
        this.buttonDisabled = this.priceModal === this.formatToDollars(this.row.price) && this.getValueOf(this.currencyModal) === this.row.currency;
      }
    },
    watch: {
      priceModal() {
        this.handleButtonState();
      },
      currencyModal() {
        this.handleButtonState();
      }
    }
  }
</script>
